"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sort = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function Sort(_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'desc' : _b, active = _a.active;
    return react_1.default.createElement(StyledSortIcon, { direction: direction, active: active });
}
exports.Sort = Sort;
function SortIcon(_a) {
    var active = _a.active, props = __rest(_a, ["active"]);
    return (react_1.default.createElement("svg", __assign({ width: "10", height: "6", viewBox: "0 0 10 6", fill: "none" }, props),
        react_1.default.createElement("path", { d: "M0 0.5L5 5.5L10 0.5H0Z", fill: active ? core_ui_1.colors.steel[500] : core_ui_1.colors.steel[300] })));
}
var StyledSortIcon = (0, styled_components_1.default)(SortIcon)(function (_a) {
    var direction = _a.direction;
    return ({
        display: 'inline',
        background: 'none',
        transform: direction === 'asc' ? 'rotate(180deg)' : undefined,
        marginLeft: 12,
        minWidth: 10,
        minHeight: 6,
    });
});
